namespace RedBullMOBILE360.Web.Services.Absher.DTOs {
    export interface AbsherStatusRequest {
        transactionId?: string;
    }
}
